













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CountTo from 'vue-count-to';
@Component({
  components: { CountTo },
})
export default class panelGroup extends Vue {
  @Prop()
  private data: any;

  public showIcon(name: string) {
    const card: any = document.getElementsByClassName('card-panel');
    if (card[0]) {
      const ref: any = this.$refs[name];
      // 查看框度是否足夠 夠在顯示ICON為了讓數字顯示更多
      // 公式外層寬度 - ICON寬度 - 左側margin -右側margin
      const width = card[0].clientWidth - 92 - 14 - 26;
      const show = width > ref.clientWidth;
      return !show;
    }
    return false;
  }
}
